// JWT token management (for email/password auth)
export const getToken = () => localStorage.getItem('auth_token');
export const setToken = (token) => localStorage.setItem('auth_token', token);
export const removeToken = () => localStorage.removeItem('auth_token');

// User data management.
// `getUser` was previously `JSON.parse(...)` raw. A corrupted localStorage
// entry (extension write, partial truncation, manual edit) would crash
// the whole app on boot. Wrap so the worst case is "user is treated as
// logged-out" + the bad value is cleared.
export const getUser = () => {
  const userData = localStorage.getItem('user_data');
  if (!userData) return null;
  try {
    return JSON.parse(userData);
  } catch (_) {
    localStorage.removeItem('user_data');
    return null;
  }
};
export const setUser = (user) => localStorage.setItem('user_data', JSON.stringify(user));
export const removeUser = () => localStorage.removeItem('user_data');

// Check if user is authenticated
export const isAuthenticated = () => {
  return !!getToken();
};

// Legacy keys to clean up on every logout. Kept here (not inline) so we
// can append to it cheaply when the next rebrand happens. The product
// was previously called "ReeltyPost"; some installs still carry the
// old language preference key from before the rename.
const LEGACY_LOCAL_STORAGE_KEYS = [
  'reeltypost_lang',          // pre-rename language preference
  'reeltypost_cookie_consent', // pre-rename consent record
];

// Clear all auth data.
// We deliberately don't import from `./onboarding` here to avoid a
// circular-import landmine – `onboarding.js` already lists the keys it
// owns, and we mirror them by name. If you bump ONBOARDING_VERSION's
// key naming, update both places.
export const clearAuth = () => {
  removeToken();
  removeUser();
  localStorage.removeItem('onboarding_complete');
  localStorage.removeItem('onboarding_version');
  // Sweep stale brand-prefixed keys so a re-login on the same browser
  // doesn't carry forward stale state from the old brand era.
  for (const key of LEGACY_LOCAL_STORAGE_KEYS) {
    try {
      localStorage.removeItem(key);
    } catch (_) {
      /* private mode / quota. Best effort */
    }
  }
};
